import React, {useState} from 'react';
import cn from 'classnames';

import YesNo from 'shared/ui/YesNo/YesNo';
import {EmailProblemBlock, IUserOutput} from 'entities/user';

import {getFormattedDate} from 'shared/lib/datetime';

import UserMenu from './UserMenu';
import UserTariffModal from './UserTariffModal';
import UserEditModal from './UserEditModal';

import {isTranslate} from '../../../../shared/lib/lang';

import styles from './Users.module.scss';

interface IPaymentRowProps {
    item: IUserOutput,
    tzString?: string | null,
}

const UserRow: React.FC<IPaymentRowProps> = ({item, tzString}) => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [tariffModalOpen, setTariffModalOpen] = useState(false);
    if (!item) return null;

    return (
        <>
            <tr className={cn(styles.rowUser, item.blocked ? styles.blockedUser : '')}>
                <td>{item.id}</td>
                <td>
                    {getFormattedDate(item.created_at,
                        {format: !isTranslate() ? 'DD.MM.YYYY, в HH:mm' : 'YYYY-MM-DD, in HH:mm', tzString})}
                </td>
                <td>
                    {getFormattedDate(item.last_activity_at,
                        {format: !isTranslate() ? 'DD.MM.YYYY, в HH:mm' : 'YYYY-MM-DD, in HH:mm', tzString})}
                </td>
                <td>{item.first_name}</td>
                <td>{item.last_name}</td>
                <td>
                    {
                        item.last_email_error !== null
                            ? <EmailProblemBlock error={item.last_email_error} />
                            : <YesNo condition={item.email_confirmed} />
                    }
                    &nbsp;
                    {item.email}
                </td>
                <td>{item.timezone}</td>
                <td>
                    {item.tariff
                        ? `${item.tariff.name}${item.tariff.is_archive ? ' (арх.)' : ''}`
                        : 'Нет тарифа'
                    }
                </td>
                <td>{
                    item.active_to
                        ? getFormattedDate(item.active_to, {tzString, format: 'DD.MM.YYYY'})
                        : 'Бессрочно'
                }</td>
                <td><YesNo condition={item.is_recurring}/></td>
                <td>{item.monitors_count}/{item.monitors_with_incidents_count}</td>
                <td><YesNo condition={item.agree_to_newsletter}/></td>
                <td>
                    <UserMenu
                        item={item}
                        onEditClick={() => setIsEditModalOpen(true)}
                        onTariffClick={() => setTariffModalOpen(true)}
                    />
                </td>
            </tr>
            <UserEditModal
                item={item}
                open={isEditModalOpen}
                handleClose={() => setIsEditModalOpen(false)}
            />
            <UserTariffModal
                item={item}
                open={tariffModalOpen}
                handleClose={() => setTariffModalOpen(false)}
            />
        </>
    );
};

export default UserRow;